import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="file code outline" {...props} />;
}

export const meta = {
  id: 'DataStructuresDetails',
  title: 'DataStructuresDetails',
  category: '',
  unique: false,
  icon: TheIcon,
  version: '1.0.0',
  description: `Manage data structures to be used throughout modules`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 890,
    height: 700
  }
};
